// Standalone API base URL. Deliberately kept OUT of firebase.js so importing it
// (MapsClient / FriendsClient, which are on the home load via syncedMap/friends)
// doesn't statically drag the Firebase SDK (firebase/app + firebase/auth, ~112KB)
// into the home bundle. Firebase Auth stays lazily imported in auth.svelte.js.
export const API_BASE = import.meta.env.VITE_API_BASE || 'https://api.livelocation.app';
